<app-navbar></app-navbar>
  <div class="container">
    <div class="text-content">
        <h2 class="terms-title">
            Политика обработки персональных данных
        </h2>
        <p class="text">
            На сайте https://wineincognito.ru/ и его поддоменах (далее — Сайт) используются файлы cookie.
        </p>
        <p class="text">
            Файлы cookie — это небольшие текстовые файлы, которые после просмотра Пользователем фрагментов Сайта сохраняются
            на его устройстве. Использование файлов cookie позволяет ООО «Wineincognito» (далее – Оператор) контролировать
            доступность Сайта, анализировать данные, а также понимать, как развивать оказываемые услуги.
        </p>
        <p class="text">
            На Сайте используются следующие типы файлов cookie:
        </p>
        <p class="text">
            1. Технические файлы cookie: они необходимы для корректной работы Сайта и вспомогательных сервисов. Такие файлы
            cookie позволяют определять аппаратное и программное обеспечение устройства Пользователя; выявлять ошибки при
            работе Сайта; тестировать новые функции для повышения производительности Сайта.
        </p>
        <p class="text">
            2. Файлы cookie для аутентификации: они необходимы, чтобы запоминать Пользователей. Благодаря таким файлам
            Пользователю при новом посещении Сайта не нужно заново вводить авторизационные данные.
        </p>
        <p class="text">
            3. Аналитические файлы cookie: они позволяют подсчитывать количество Пользователей Сайта; определять, какие
            действия Пользователь совершает на Сайте (посещаемые страницы, время и количество просмотренных страниц). Сбор
            аналитических данных осуществляется через партнеров, в том числе Google Analytics, Yandex Metrika.
        </p>
        <p class="text">
            4. Рекламные файлы cookie: они помогают анализировать, из каких источников Пользователь перешел на Сайт, а также
            персонализировать рекламные сообщения.
        </p>
        <p class="text">
            Срок хранения файлов cookie зависит от конкретного типа, но в любом случае не превышает срока, необходимого для
            достижения целей обработки персональных данных.
        </p>
        <p class="text">
            При посещении Сайта Оператор запрашивает согласие Пользователя на использование файлов cookie.
        </p>
        <p class="text">
            Для прекращения обработки файлов cookie Пользователь может изменить настройки используемых браузеров на всех
            устройствах (компьютер, мобильные устройства).
        </p>
        <p class="text">
            <span class="subtitle">ВАЖНО:</span> при отказе от использования файлов cookie отдельные функции Сайта могут быть недоступными, что повлияет
            на возможность использования Сайта.
        </p>
    </div>
  </div>

 <app-footer></app-footer>